/* Neurozyn landing pages — light interactivity (no dependencies) */
(function () {
  'use strict';

  /* Scroll reveal */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* Flavor selector — updates the chosen-flavor label (and optional hero image) */
  var flavorWraps = document.querySelectorAll('[data-flavor-group]');
  flavorWraps.forEach(function (group) {
    var btns = group.querySelectorAll('.flavor');
    var label = document.querySelector('[data-flavor-label]');
    var heroImg = document.querySelector('[data-flavor-img]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (label) { label.textContent = btn.textContent.trim(); }
        var src = btn.getAttribute('data-img');
        if (heroImg && src) {
          heroImg.style.opacity = '0';
          window.setTimeout(function () { heroImg.src = src; heroImg.style.opacity = '1'; }, 160);
        }
        /* Point every "Proceed to Purchase" CTA at the selected variant's checkout */
        var variant = btn.getAttribute('data-variant');
        if (variant) {
          var checkoutHref = '/cart/add?id=' + variant + '&quantity=1&return_to=/checkout';
          document.querySelectorAll('[data-checkout]').forEach(function (a) { a.setAttribute('href', checkoutHref); });
        }
      });
    });
  });

  /* Sticky buy bar appears once the hero scrolls out of view */
  var sticky = document.querySelector('.stickybar');
  var heroEl = document.querySelector('.hero');
  if (sticky && heroEl && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { sticky.classList.toggle('show', !e.isIntersecting); });
    }, { threshold: 0 });
    so.observe(heroEl);
  }

  /* FAQ — keep one item open at a time within a group */
  var faq = document.querySelector('.faq');
  if (faq) {
    var items = faq.querySelectorAll('details.faq-item');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          items.forEach(function (other) { if (other !== d) other.open = false; });
        }
      });
    });
  }

  /* Video review carousel — arrow nav + pause others on play */
  document.querySelectorAll('.vid-rail-wrap').forEach(function (wrap) {
    var rail = wrap.querySelector('.vid-rail');
    if (!rail) return;
    var step = function (dir) {
      var card = rail.querySelector('.vid-card');
      var w = card ? card.getBoundingClientRect().width + 14 : 246;
      rail.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    var prev = wrap.querySelector('.vid-prev');
    var next = wrap.querySelector('.vid-next');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });
  var railVideos = document.querySelectorAll('.vid-rail video');
  railVideos.forEach(function (v) {
    v.addEventListener('play', function () {
      railVideos.forEach(function (o) { if (o !== v) o.pause(); });
    });
  });
})();
